const SNACKBAR_ALERT_CLASS_NAME = 'snackbar-alert';

export default SNACKBAR_ALERT_CLASS_NAME;
